import { type ReactElement } from "react";
import ReactHtmlParser from "react-html-parser";

const toHTML = (html: string): ReactElement[] => {
  const result = html.replace("\u2028", "").replace(/\n/g, "<br />");
  return ReactHtmlParser(result);
};

export const htmlParser = { toHTML };
